export default "__VITE_ASSET__CYwF2B6t__"